import {IEnquiryFormErrorMessages} from '@/dictionaries/components/enquiryForm/types';
import * as yup from 'yup';

export function getTranslatedSchema(dict: IEnquiryFormErrorMessages) {
  return yup.object().shape({
    name: yup.string().required(dict.name),
    surname: yup.string().required(dict.surname),
    country_info: yup.object().shape({
      name: yup.string().required(),
      code: yup.string().required(),
      id: yup.number().required(),
      phone: yup.object().shape({
        code: yup.number().required(),
        country: yup.string().required(),
      }),
    }),
    email: yup.string().email(dict.email).required(dict.email),
    phone: yup
      .string()
      .typeError(dict.phone.typeError)
      .required(dict.phone.required),
    dates: yup.object().shape({
      start: yup
        .date()
        .default(null)
        .nullable()
        .test('is-not-null', dict.dates.checkIn, function (value) {
          return value !== null;
        }),
      end: yup.date().default(null).nullable(),
    }),
    flexible: yup.boolean().optional(),
    adults: yup.number().default(0),
    children: yup.number().default(0),
    infants: yup.number().default(0),
    terms: yup.boolean().oneOf([true], dict.terms).required(dict.terms),
    note: yup.string().optional(),
  });
}

export function getBaseTranslatedSchema(dict: IEnquiryFormErrorMessages) {
  return getTranslatedSchema(dict).pick([
    'name',
    'surname',
    'email',
    'phone',
    'dates',
    'terms',
  ]);
}
